import { render } from "./DivisionLeadersSunB.vue?vue&type=template&id=69f9b2b9&scoped=true"
import script from "./DivisionLeadersSunB.vue?vue&type=script&scoped=true&lang=js"
export * from "./DivisionLeadersSunB.vue?vue&type=script&scoped=true&lang=js"

import "./DivisionLeadersSunB.vue?vue&type=style&index=0&id=69f9b2b9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jgurl\\KontraWebsite\\KontraSports\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69f9b2b9"]])

export default __exports__